'use client';

import { useRef } from 'react';
import { useServerInsertedHTML } from 'next/navigation';

export default function Subdomain({ subdomain }: { subdomain: string }) {
  const isServerInserted = useRef(false);
  useServerInsertedHTML(() => {
    if (isServerInserted.current) return;
    isServerInserted.current = true;
    return <script id="subdomain">{`window.__subdomain = '${subdomain}'`}</script>;
  });

  return null;
}
